import React from 'react';
import { motion } from 'framer-motion';

interface AnimatedArrowProps {
  className?: string;
  isHovered?: boolean;
}

const AnimatedArrow: React.FC<AnimatedArrowProps> = ({ className = "", isHovered = false }) => {
  return (
    <motion.svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      initial="initial"
      animate={isHovered ? "hover" : "initial"}
    >
      <motion.path
        d="M5 12H19"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        variants={{
          initial: { pathLength: 1, x: 0 },
          hover: { pathLength: 1, x: 3 }
        }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
      />
      <motion.path
        d="M13 5L20 12L13 19"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        variants={{
          initial: { x: 0 },
          hover: { x: 5 }
        }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
      />
    </motion.svg>
  );
};

export default AnimatedArrow;
